/** Posted Note — a single session-wide note per client, shown to therapists during data collection. */
export const GET_POSTED_NOTE = 'GET_POSTED_NOTE';
export const GET_POSTED_NOTE_SUCCESS = 'GET_POSTED_NOTE_SUCCESS';
export const CREATE_POSTED_NOTE = 'CREATE_POSTED_NOTE';
export const EDIT_POSTED_NOTE = 'EDIT_POSTED_NOTE';
export const DELETE_POSTED_NOTE = 'DELETE_POSTED_NOTE';
